<template>
  <div id="liga-personal-menu">
    
		<ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Duel</li>
      <li class="active">Menu Liga Personal</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Pilih Menu Liga Personal</h1>
    <!-- end page-header -->

    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="widget widget-stats bg-purple">
          <div class="stats-icon">
						<img 
							src="https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png" 
							alt="liga-schedule-logo" 
							style="max-width: 80px"
						>
					</div>
          <div class="stats-info">
            <p>Schedule</p>
          </div>
          <div class="stats-link">
            <router-link :to="{path: '/liga-personal/schedule'}">Lihat Jadwal <i class="fa fa-arrow-circle-o-right"></i></router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="widget widget-stats bg-blue">
          <div class="stats-icon">
						<img 
							src="https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_physics.png" 
							alt="liga-brackets-logo" 
							style="max-width: 80px"
						>
					</div>
          <div class="stats-info">
            <p>Brackets</p>
          </div>
          <div class="stats-link">
            <router-link :to="{path: '/liga-personal/brackets'}">Lihat Brackets <i class="fa fa-arrow-circle-o-right"></i></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'liga-personal-menu'
}
</script>


// WEBPACK FOOTER //
// LigaPersonalMenu.vue?78b827da